// test638
(638 && 0);
